export default "__VITE_ASSET__311cd87a__"